module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAAAAXNSR0IArs4c6QAAAOhJREFUKBWNkbESwUAQhnePB1AnnoDCQ5BW5xEElURvmDxAomMGL0CnJG8jyYxOLTPWrcxlXMjINnv73337790BVAwiwuklWrthZDOCVTiG3DDeyGwDIgmEce0fqEHZYQTCRCjwQPTV5AcEAsU2sMzJe1TnHHly6E7DMAfLNj64WRnk94wRynGRIQKa82EpnBhetCDN78QbMthJQVzXQUAKT16+Xfr3JD7OErxJx2GmyoYCdn43c8o1XjhhNKcneUr8zAwF3abN42m6Kkrg/cpqDosQM9o/FuBSSJlpmWHnct3zq2obheIFRaWBujRG/N0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/components/History/assets/check.png
// module id = 1306
// module chunks = 0